export const SUPPORT_PAGE = '/support';
export const IDV_PAGE = '/new/verify-id';
